import l from '../../lang';
import { PaymentMethodTypes } from '../../constants';
import { getLanguage } from '../index';

const CARD_TYPES = [PaymentMethodTypes.CREDIT_CARD, 'DEBIT_CARD'];
const BANK_TYPES = [PaymentMethodTypes.BANK_TRANSFER, 'BANK_DEPOSIT', 'ONLINE_BANK_TRANSFER'];
const STANDALONE_VOUCHER_CODES = ['PQ', 'BL'];

const commissionLocale = () => {
  const lang = getLanguage();
  if (lang === 'en') return 'en-US';
  if (lang === 'pt') return 'pt-BR';
  return 'es-AR';
};

const formatAmount = value =>
  Number(value).toLocaleString(commissionLocale(), { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const formatCommission = data => {
  const percentage = data?.percentageFee ? Number(data.percentageFee) : 0;
  const fixed = data?.fixedFee ? Number(data.fixedFee) : 0;
  const percentageFee = percentage ? `${formatAmount(percentage)}%` : '';
  const fixedFee = fixed ? `USD ${formatAmount(fixed)}` : '';
  return percentageFee + (percentageFee && fixedFee ? ' + ' : '') + fixedFee;
};

export const formatGroupCommission = methods => {
  const labels = [...new Set(methods.map(formatCommission).filter(Boolean))];
  if (!labels.length) return '-';
  if (labels.length === 1) return labels[0];
  return labels.slice(0, 2).join(' / ');
};

const isStandaloneVoucher = method => {
  const code = `${method.code || ''}`.toUpperCase();
  const name = `${method.name || ''}`.toLowerCase();
  return STANDALONE_VOUCHER_CODES.includes(code) || name === 'pix' || name.includes('boleto');
};

export const paymentMethodGroupKey = method => {
  if (CARD_TYPES.includes(method.type)) return 'CARD';
  if (BANK_TYPES.includes(method.type)) return 'BANK';
  if (method.type === PaymentMethodTypes.VOUCHER && isStandaloneVoucher(method)) {
    return `NAME:${`${method.code || method.name}`.toUpperCase()}`;
  }
  return 'CASH';
};

export const paymentMethodGroupLabel = (key, sample) => {
  if (key === 'CARD') return l('paymentMethod.type.cardGroup');
  if (key === 'BANK') return l('paymentMethod.type.BANK_TRANSFER');
  if (key === 'CASH') return l('paymentMethod.type.VOUCHER');
  const code = `${sample?.code || ''}`.toUpperCase();
  const name = `${sample?.name || ''}`.toLowerCase();
  if (code === 'BL' || name.includes('boleto')) return l('paymentMethod.type.boleto');
  return sample?.name || key;
};

export const paymentMethodGroupRank = key => {
  if (key === 'CARD') return 0;
  if (key.includes('PQ') || key.endsWith(':PIX')) return 1;
  if (key === 'BANK') return 2;
  if (key === 'CASH') return 4;
  return 3;
};

export const types = type => {
  switch (type) {
    case PaymentMethodTypes.VOUCHER:
      return l('paymentMethod.type.VOUCHER');
    case PaymentMethodTypes.BANK_TRANSFER:
      return l('paymentMethod.type.BANK_TRANSFER');
    case PaymentMethodTypes.CREDIT_CARD:
      return l('paymentMethod.type.CREDIT_CARD');
    case PaymentMethodTypes.ONLINE_BANK_TRANSFER:
      return l('paymentMethod.type.ONLINE_BANK_TRANSFER');
    default:
      return type;
  }
};

export const countryFilter = paymentMethods => {
  const data = {};
  paymentMethods.forEach(pm => {
    if (!data[pm.country]) {
      data[pm.country] = [];
    }
    data[pm.country].push(pm);
  });
  return data;
};

export const countryName = countryCode => {
  if (l(`countryCode.${countryCode}`)) {
    return l(`countryCode.${countryCode}`);
  }
  return countryCode;
};

export const getCommissions = data => {
  const percentage = data.percentageFee ? Number(data.percentageFee).toFixed(2) : 0;
  const percentageFee = `${percentage ? `${percentage}%` : ''}`;
  const fixedFeeNumber = data.fixedFee ? Number(data.fixedFee).toFixed(2) : 0;
  const fixedFee = `${fixedFeeNumber ? `USD ${fixedFeeNumber}` : ''}`;
  return percentageFee + (percentageFee && fixedFee ? ' + ' : '') + fixedFee;
};
